import React from "react";
import { STATUS, STATUS_COLORS } from "utils/constants/ui";
import classnames from "classnames";
import { getIconForUID } from "components/FormerEditor/utils";
import { COLORS } from "utils/styles";

const PhaseList = ({ phases, clamp = false }) => {
  return (
    <ul className="ma0 list ba pa2 br2 hairline-1">
      {phases.map((phase, phaseIx) => {
        const isLast = phaseIx === phases.length - 1;
        const hasMultiple = phases.length > 1;
        const clampStart = clamp && !phaseIx;
        const clampEnd = clamp && phaseIx === phases.length - 1;

        const paddingBottom = hasMultiple && !isLast ? 18 : 0;

        let ringColor = "b--primary";
        const status = phase && phase.status;
        const color = STATUS_COLORS[status] || COLORS.blue;
        if (status) {
          if (status === STATUS.DANGER) {
            ringColor = "b--error";
          } else if (status === STATUS.WARNING) {
            ringColor = "b--warning";
          } else if (status === STATUS.SUCCESS) {
            ringColor = "b--success";
          }
        }

        let optionLabels;
        if (phase.optionLabel) {
          if (Array.isArray(phase.optionLabel)) {
            optionLabels = (
              <ul className="list ma0 pa0 pt1">
                {phase.optionLabel.map((label, labelIx) => (
                  <div key={labelIx} className="f6 lh-copy">
                    {label}
                  </div>
                ))}
              </ul>
            );
          } else {
            optionLabels = (
              <div className="f6 pt1 lh-copy">{phase.optionLabel}</div>
            );
          }
        }
        let markerContent = (
          <div className="f6 fw5 lh-copy">{`${phaseIx + 1}`}</div>
        );
        if (phase.icon) {
          const Icon = getIconForUID(phase.icon);
          markerContent = <Icon size={20} color={color} />;
        }

        return (
          <div
            key={phaseIx}
            style={{
              paddingBottom
            }}
            className={classnames("w-100 flex flex-row ml3 relative", {
              "node__row": !clampEnd,
              "items-center": !optionLabels
            })}
          >
            <div className="node__marker flex items-center justify-center">
              <div
                className={`node__marker--dot bg-white bw1 ba br-100 flex items-center justify-center ${ringColor}`}
              >
                {markerContent}
              </div>
            </div>
            <div className="w-100 flex flex-column">
              <div className="f5 fw6">{phase.fieldLabel}</div>
              {optionLabels}
            </div>
            <style jsx global>
              {`
                .node__row::before {
                  position: absolute;
                  top: ${clamp ? 18 : 2}px;
                  bottom: ${clamp ? -2 : 0}px;
                  left: 2px;
                  display: block;
                  width: 2px;
                  content: "";
                  background-color: #d6d6d6;
                }
                .node__marker {
                  position: relative;
                  z-index: 1;
                  display: flex;
                  width: 38px;
                  height: 38px;
                  margin-right: 8px;
                  margin-left: -15px;
                }
                .node__marker--dot {
                  width: 34px;
                  height: 34px;
                }
              `}
            </style>
          </div>
        );
      })}
    </ul>
  );
};

export default PhaseList;
